import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { APP_ROUTES } from '../constants/app-routes.const';
import { AuthStore } from '../stores/auth.store';

/**
 * Guard kiểm tra người dùng đã đăng nhập chưa.
 * Dựa trên sự tồn tại của Token trong AuthStore.
 */
export const authGuard: CanActivateFn = () => {
  const authStore = inject(AuthStore);
  const router = inject(Router);

  if (authStore.isAuthenticated()) {
    return true;
  }

  // Nếu chưa đăng nhập, chuyển hướng về trang login
  return router.parseUrl('/' + APP_ROUTES.LOGIN);
};
